// extracted by mini-css-extract-plugin
export var blockText__description = "screen6-module--block-text__description--ab6ef";
export var blockText__title = "screen6-module--block-text__title--32660";
export var howWorks = "screen6-module--how-works--f4e93";
export var howWorks__block = "screen6-module--how-works__block--61bf7";
export var howWorks__blockText = "screen6-module--how-works__block-text--c895e";
export var howWorks__blockText1 = "screen6-module--how-works__block-text1--f166b";
export var howWorks__blockText2 = "screen6-module--how-works__block-text2--da0b0";
export var howWorks__blockText3 = "screen6-module--how-works__block-text3--c0219";
export var howWorks__blockText4 = "screen6-module--how-works__block-text4--d9dfa";
export var howWorks__block__wrapper = "screen6-module--how-works__block__wrapper--071dd";
export var howWorks__img__wrapper = "screen6-module--how-works__img__wrapper--01365";
export var howWorks__title = "screen6-module--how-works__title--02c0a";
export var lessonDuration__block = "screen6-module--lesson-duration__block--fc563";
export var lessonDuration__min = "screen6-module--lesson-duration__min--7312b";
export var lessonDuration__num = "screen6-module--lesson-duration__num--0b470";
export var lessonDuration__text = "screen6-module--lesson-duration__text--140ce";
export var lessonExample__text = "screen6-module--lesson-example__text--d9282";